import * as types from '../../actionTypes';

const initialState = {
  data: {},
  isLoading: false,
  message: "",
  status:""
};


const skillsReducer = (state = initialState, action) => {
  console.log('prd',action);
  switch (action.type) {
    case types.ADD_SKILLS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.ADD_SKILLS_SUCCESS:
        
      return {
        ...state,
        isLoading: false,
        status:action.payload.status,
        message:action.payload.message
      };
    case types.ADD_SKILLS_FAILURE:
        console.log(action.payload);
      return {
        ...state,
        isLoading: false,
        data:{},
        status:action.payload.status,
        message:action.payload.message
      };
      case types.RESET_DATA:
        return {
          ...state,
          isLoading: false,
          data:{},
          status:false,
          message:""
        };

    default:
      return state;
  }
};

export default skillsReducer;
